// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';

import { bookingShape, locationShape, notesShape } from 'constants/propTypes';

import NotesAndHistorySection from './NotesAndHistorySection';
import OperationalRemarkSection from './OperationalRemarkSection';
import { getDefaultTab } from './Notes.utils';
import { StyledPage } from './Notes.styles';

const Notes = ({ booking, bookingReference, notes, location, dates, currentRemark, bookingStatus }) => (
  <StyledPage columns={14}>
    <OperationalRemarkSection bookingReference={bookingReference} currentRemark={currentRemark} />
    <NotesAndHistorySection
      booking={booking}
      defaultTab={getDefaultTab(location)}
      bookingReference={bookingReference}
      notes={notes}
      dates={dates}
      bookingStatus={bookingStatus}
    />
  </StyledPage>
);

Notes.propTypes = {
  booking: bookingShape,
  bookingReference: PropTypes.string.isRequired,
  location: locationShape.isRequired,
  notes: notesShape.isRequired,
  dates: PropTypes.shape({
    confirmedTimestamp: PropTypes.string,
    cancelledTimestamp: PropTypes.string,
    expiryTimestamp: PropTypes.string,
    voidExpiryDate: PropTypes.string,
    createTimestamp: PropTypes.string,
    updatedTimestamp: PropTypes.string
  }),
  currentRemark: PropTypes.string,
  bookingStatus: PropTypes.string
};

export default Notes;
